import React, { useEffect, useState } from 'react'
import CustomComponent from './DisplayComponent'
import '../.././App.css'
import { useLoadData } from '../Load/LoadDataProvider'

interface StatBox {
	sliderValues: any
	colorPalette: string[]
	translation: string
	is121: boolean
}

const StatBoxComponent: React.FC<StatBox> = ({ sliderValues, colorPalette, translation, is121 }) => {
	const [localSliderValues, setLocalSliderValues] = useState<any>(sliderValues)

	const handleSliderChange = (sliderName: any, newValue: number) => {
		setLocalSliderValues((prevValues: any) => ({ ...prevValues, [sliderName]: newValue }))
	}

	function customPower(x: number, exp: number): number {
		// Handle negative values separately
		if (x < 0) {
			// Check if the exponent is a rational number with an odd numerator
			if (exp % 2 !== 0) {
				return -Math.pow(-x, exp)
			} else {
				// If the exponent is even, the result is not a real number
				return NaN
			}
		} else {
			// For non-negative values, use Math.pow directly
			return Math.pow(x, exp)
		}
	}

	return (
		<div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
			<CustomComponent
						imageProps={{
							imageUrl: process.env.PUBLIC_URL + '/images/sword.png',
							colorPalette: colorPalette
						}}
						headerText={translation + 'Sword'}
						lines={[{ text: 'Attack Damage : ' + (sliderValues.hardness + 1).toFixed(2) }, { text: 'Attack Speed  : 1.6' }]}
					/>
					<CustomComponent
						imageProps={{
							imageUrl: process.env.PUBLIC_URL + '/images/axe.png',
							colorPalette: colorPalette
						}}
						headerText={translation + 'Axe'}
						lines={[
							{
								text:
									'Attack Damage : ' +
									(is121
										? sliderValues.hardness + sliderValues.density + 1
										: Math.floor(customPower((sliderValues.hardness - 3.4) * 2.3, 1 / 3)) +
											7 +
											(sliderValues.axe_damage === undefined ? 0 : sliderValues.axe_damage)
									).toFixed(2)
							},
							{
								text: 'Attack Speed  : ' + (Math.ceil(customPower(sliderValues.mining_speed - 6, 0.2) - 0.5 + 10) / 10 - 0.1).toFixed(2)
							},
							{ text: 'Mining Speed  : ' + sliderValues.mining_speed }
						]}
					/>
					<CustomComponent
						imageProps={{
							imageUrl: process.env.PUBLIC_URL + '/images/helmet.png',
							colorPalette: colorPalette
						}}
						headerText={translation + 'Helmet'}
						lines={[
							{
								text: 'Armor                  : ' + Math.floor(sliderValues.hardness / 2).toFixed(2)
							},
							{
								text:
									'Armor Tougness         : ' +
									(is121
										? (sliderValues.armor_toughness ?? sliderValues.toughness ?? 0)
										: sliderValues.mining_level === 2
											? 0
											: ((sliderValues.mining_level - 2) / Math.abs(sliderValues.mining_level - 2) / 2 + 0.5) * (sliderValues.mining_level - 1)
									).toFixed(2)
							},
							{
								text:
									'Knockback Ressistance  : ' +
									(is121
										? (sliderValues.knockback_ressistance ?? Math.max(0, (sliderValues.toughness ?? 0) - 2))
										: sliderValues.mining_level === 3
											? 0
											: ((sliderValues.mining_level - 3) / Math.abs(sliderValues.mining_level - 3) / 2 + 0.5) * (sliderValues.mining_level - 3)
									).toFixed(2)
							}
						]}
					/>
					<CustomComponent
						imageProps={{
							imageUrl: process.env.PUBLIC_URL + '/images/chestplate.png',
							colorPalette: colorPalette
						}}
						headerText={translation + 'Chestplate'}
						lines={[
							{
								text: 'Armor                  : ' + (sliderValues.hardness + 2 - Math.ceil(sliderValues.flexibility / 4)).toFixed(2)
							},
							{
								text:
									'Armor Tougness         : ' +
									(is121
										? (sliderValues.armor_toughness ?? sliderValues.toughness ?? 0)
										: sliderValues.mining_level === 2
											? 0
											: ((sliderValues.mining_level - 2) / Math.abs(sliderValues.mining_level - 2) / 2 + 0.5) * (sliderValues.mining_level - 1)
									).toFixed(2)
							},
							{
								text:
									'Knockback Ressistance  : ' +
									(is121
										? (sliderValues.knockback_ressistance ?? Math.max(0, (sliderValues.toughness ?? 0) - 2))
										: sliderValues.mining_level === 3
											? 0
											: ((sliderValues.mining_level - 3) / Math.abs(sliderValues.mining_level - 3) / 2 + 0.5) * (sliderValues.mining_level - 3)
									).toFixed(2)
							}
						]}
					/>
					<CustomComponent
						imageProps={{
							imageUrl: process.env.PUBLIC_URL + '/images/leggings.png',
							colorPalette: colorPalette
						}}
						headerText={translation + 'Leggings'}
						lines={[
							{
								text:
									'Armor                  : ' +
									(((sliderValues.hardness - Math.ceil(sliderValues.hardness / 6.5) + Math.ceil(sliderValues.hardness / 4.5) - 1) / 7) * 7).toFixed(2)
							},
							{
								text:
									'Armor Tougness         : ' +
									(is121
										? (sliderValues.armor_toughness ?? sliderValues.toughness ?? 0)
										: sliderValues.mining_level === 2
											? 0
											: ((sliderValues.mining_level - 2) / Math.abs(sliderValues.mining_level - 2) / 2 + 0.5) * (sliderValues.mining_level - 1)
									).toFixed(2)
							},
							{
								text:
									'Knockback Ressistance  : ' +
									(is121
										? (sliderValues.knockback_ressistance ?? Math.max(0, (sliderValues.toughness ?? 0) - 2))
										: sliderValues.mining_level === 3
											? 0
											: ((sliderValues.mining_level - 3) / Math.abs(sliderValues.mining_level - 3) / 2 + 0.5) * (sliderValues.mining_level - 3)
									).toFixed(2)
							}
						]}
					/>
					<CustomComponent
						imageProps={{
							imageUrl: process.env.PUBLIC_URL + '/images/boots.png',
							colorPalette: colorPalette
						}}
						headerText={translation + 'Boots'}
						lines={[
							{
								text: 'Armor                  : ' + Math.floor(sliderValues.hardness / 2 - Math.floor(sliderValues.density / 4)).toFixed(2)
							},
							{
								text:
									'Armor Tougness         : ' +
									(is121
										? (sliderValues.armor_toughness ?? sliderValues.toughness ?? 0)
										: sliderValues.mining_level === 2
											? 0
											: ((sliderValues.mining_level - 2) / Math.abs(sliderValues.mining_level - 2) / 2 + 0.5) * (sliderValues.mining_level - 1)
									).toFixed(2)
							},
							{
								text:
									'Knockback Ressistance  : ' +
									(is121
										? (sliderValues.knockback_ressistance ?? Math.max(0, (sliderValues.toughness ?? 0) - 2))
										: sliderValues.mining_level === 3
											? 0
											: ((sliderValues.mining_level - 3) / Math.abs(sliderValues.mining_level - 3) / 2 + 0.5) * (sliderValues.mining_level - 3)
									).toFixed(2)
							}
						]}
					/>
		</div>
	)
}

export default StatBoxComponent
